import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProjectConnection, BackendQueryProjectsArgs } from 'src/types/backend';

import { PROJECT_FROM_LIST_FRAGMENT } from './schema';

const PROJECTS_PAGE_SIZE = 12;

const QUERY = gql`
  query Projects(
    $customerId: ID!
    $cursor: String
    $filter: JSON
    $workspaceId: ID
    $projectFolderId: ID
    $sortOrder: SortOrderEnum
    $sortField: ProjectSortFieldEnum
  ) {
    projects(
      customerId: $customerId
      first: ${PROJECTS_PAGE_SIZE}
      after: $cursor,
      filter: $filter
      workspaceId: $workspaceId
      projectFolderId: $projectFolderId
      sortOrder: $sortOrder
      sortField: $sortField
    ) {
      edges {
        node {
          ...ProjectFromList
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PROJECT_FROM_LIST_FRAGMENT}
`;

type Variables = Pick<
  BackendQueryProjectsArgs,
  'customerId' | 'workspaceId' | 'projectFolderId' | 'sortOrder' | 'sortField'
> & {
  cursor?: string;
  filter?: Record<string, unknown>;
};
type Result = BackendProjectConnection;

export const queryProjects = async ({
  customerId,
  workspaceId,
  cursor,
  filter,
  projectFolderId,
  sortOrder,
  sortField,
}: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      cursor,
      filter: JSON.stringify(filter),
      workspaceId,
      projectFolderId,
      sortOrder,
      sortField,
    },
  });
  return getSingleProp<Result>(result.data);
};
